<template>
  <div class="p-page-wrapper">
    <template v-if="!currentProjectId">
      <v-row>
        <v-col>
          <p-no-data
            :text="$t('noProjects')"
            :hide-btn="true"
            img="project.png"
            class="p-no-data-mt"
          ></p-no-data>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row class="pt-4">
        <v-col cols="12" md="4">
          <totals-table></totals-table>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-center">
          <budget-chart-donut />
        </v-col>
        <v-col cols="12" md="5">
          <budget-chart-bar />
        </v-col>
      </v-row>

      <v-row class="mt-6">
        <v-col cols="12" md="6">
          <budget-table
            :income="true"
            @change="loadBudgetTotal(currentProjectId)"
          ></budget-table>
        </v-col>
        <v-col cols="12" md="6">
          <budget-table
            :income="false"
            @change="loadBudgetTotal(currentProjectId)"
          ></budget-table>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col>
          <members-table @change="loadBudgetTotal(currentProjectId)"></members-table>
        </v-col>
      </v-row>
    </template>
  </div>
</template>


<script>
import accessHelper from '@/helpers/access.helper'

import { mapGetters, mapActions } from 'vuex'

import PNoData from '@/components/PNoData'

import BudgetTable from './BudgetTable'
import TotalsTable from './BudgetTotalsTable'
import MembersTable from './BudgetMembersTable'
import BudgetChartDonut from './BudgetChartDonut'
import BudgetChartBar from './BudgetChartBar'

import snackbarMixin from '@/mixins/snackbar.mixin'
import pageMixin from '@/mixins/page.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PNoData,
    BudgetTable,
    TotalsTable,
    MembersTable,
    BudgetChartDonut,
    BudgetChartBar
  },


  mixins: [
    snackbarMixin,
    pageMixin,
    accessMixin
  ],


  data () {
    return {
      chartOptions: {
        legend: { position: 'right' },
        layout: {
          padding: {
            top: -80
          }
        }
      }
    }
  },


  computed: {
    ...mapGetters('project', ['currentProjectId']),
    ...mapGetters('user', ['currentUser', 'currentUserAndProjectClaims'])
  },


  watch: {
    async currentProjectId () {
      if (!this.currentProjectId) return false
      if (!accessHelper.isRouteAvailableForCurrentUserAndProject(this.$route.name, this.currentUser, this.currentUserAndProjectClaims)) {
        this.$router.push({ name: 'accessDenied' }).catch(() => {})
        return false
      }

      this.startPageLoading()

      await Promise.all([
        this.loadMembersByProject(this.currentProjectId),
        this.loadBudgetTotal(this.currentProjectId),
        this.loadBudgets()
      ])

      this.stopPageLoading()
    }
  },


  methods: {
    ...mapActions('member', ['loadMembersByProject']),
    ...mapActions('budget', ['loadBudgets', 'loadBudgetTotal']),
    ...mapActions('budgetCategory', ['loadBudgetCategories']),
    ...mapActions('contact', ['loadShortContacts'])
  },


  async created () {
    this.setPageTitle(this.$t('nav.budget'))
    if (!this.currentProjectId) return false
    try {
      this.startPageLoading()
      await Promise.all([
        this.loadBudgetTotal(this.currentProjectId),
        this.loadShortContacts(),
        this.loadMembersByProject(this.currentProjectId),
        this.loadBudgetCategories()
      ])
      await this.loadBudgets()
    } catch (error) {
      this.showSnackbarError()
      this.$log.error(error)
    } finally {
      this.stopPageLoading()
    }
  }
}
</script>
